import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CandidateSubmissionType } from 'components/JobQueue/utils';
import { SalesRoute } from 'config';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import CandidateCard from './CandidateCard';

// interface Candidate {
//   id: string;
//   matchPercentage: number;
//   visaStatus: string;
//   source: string;
//   name: string;
//   availability: string;
//   availabilityDate: string;
//   email: string;
//   phone: string;
//   location: string;
//   isSelected: boolean;
//   topSkills?: string;
// }

interface MatchesAndShortlistProps {
  matches: CandidateSubmissionType[];
  shortlisted: CandidateSubmissionType[];
  onSelectCandidate: (candidateId: string, selected: boolean) => void;
  onExpandCandidate?: (candidateId: string) => void;
  setActiveTab: (tabIndex: number) => void;
  activeTab: number;
  onConfirmSubmit?: (
    selected: CandidateSubmissionType[],
  ) => Promise<void> | void;
  setMore: (more: boolean) => void;
  jobId: string | undefined;
}

const MatchesAndShortlist: React.FC<MatchesAndShortlistProps> = ({
  matches,
  shortlisted,
  onSelectCandidate,
  onExpandCandidate,
  activeTab,
  setActiveTab,
  onConfirmSubmit,
  setMore,
  jobId,
}) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleSelectCandidate = (candidateId: string, selected: boolean) => {
    onSelectCandidate(candidateId, selected);
  };

  const handleExpandCandidate = (candidateId: string) => {
    if (onExpandCandidate) {
      onExpandCandidate(candidateId);
    }
  };

  const [openConfirm, setOpenConfirm] = React.useState(false);
  const selectedShortlist = React.useMemo(
    () => shortlisted.filter((c: any) => c.selectedForSubmit),
    [shortlisted],
  );
  const getMatchColor = (percentage: number) => {
    // if (percentage >= 90) return '#10b981'; // Green
    if (percentage >= 80) return '#EBF0FF'; // Blue
    // if (percentage >= 70) return '#f59e0b'; // Orange
    // return '#6b7280'; // Gray
    return '#EBF0FF';
  };
  const handleOpenConfirm = () => setOpenConfirm(true);
  const handleCloseConfirm = () => setOpenConfirm(false);
  const handleSubmitConfirm = async () => {
    try {
      if (onConfirmSubmit) {
        await onConfirmSubmit(selectedShortlist);
      }
    } finally {
      setOpenConfirm(false);
    }
  };
  console.log(matches, 'matches');

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        height: '100%',
        padding: '24px',
        paddingBottom: 'unset !important',
      }}>
      {/* Tabs */}
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '24px',
        }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            '& .Mui-selected': {
              color: '#ef4444',
            },
            '& .MuiTab-root': {
              color: '#6b7280',
              fontFamily: 'Red Hat Display Medium',
              fontSize: '14px',
              fontWeight: '500',
              textTransform: 'none',
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#ef4444',
            },
          }}>
          <Tab label={`Matches (${matches?.length})`} />
          <Tab label={`Shortlisted (${shortlisted?.length})`} />
        </Tabs>

        <Typography
          onClick={() => setMore(true)}
          sx={{
            '&:hover': {
              color: '#ef4444',
            },
            color: '#6b7280',
            cursor: 'pointer',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '14px',
            fontWeight: '500',
          }}>
          More &gt;
        </Typography>
      </div>

      {/* Content */}
      <div style={{ height: 'calc(100vh - 165px)', overflowY: 'auto' }}>
        {activeTab === 0 ? (
          // Matches Tab
          <div>
            {matches?.length > 0 ? (
              matches?.map((candidate) => (
                <div
                  key={candidate?.id}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    if (jobId && candidate.id) {
                      navigate(
                        `${SalesRoute.VIEWipriseCANDIDATE}/${jobId}/${candidate.id}`,
                        {
                          state: { candidateDetails: candidate },
                        },
                      );
                    }
                  }}>
                  <CandidateCard
                    matchPercentage={candidate?.matchPercentage}
                    visaStatus={candidate?.candidate?.workStatus?.name}
                    source={candidate?.candidate?.source}
                    name={
                      candidate?.candidate?.firstName
                        ? candidate?.candidate?.firstName
                        : '' + ' ' + candidate?.candidate?.middleName
                        ? candidate?.candidate?.middleName
                        : '' + ' ' + candidate?.candidate?.lastName
                        ? candidate?.candidate?.lastName
                        : ''
                    }
                    availability={candidate?.candidate?.benchStatus}
                    availabilityDate={candidate?.candidate?.benchAvailability}
                    email={candidate?.candidate?.email}
                    phone={
                      candidate?.candidate?.phone ||
                      candidate?.candidate?.mobileNumber
                    }
                    location={
                      candidate.candidate?.city +
                      ', ' +
                      candidate.candidate?.state +
                      ', ' +
                      candidate.candidate?.country
                    }
                    isSelected={(candidate as any).selectedForSubmit}
                    topSkills={(candidate as any)?.topSkills
                      ?.map((skill) => skill)
                      .filter(Boolean)
                      .join(', ')}
                    onSelect={(selected) =>
                      handleSelectCandidate(candidate.id, selected)
                    }
                    onExpand={() => handleExpandCandidate(candidate.id)}
                    isShortList={false}
                    submittedOn={''}
                    submittedBy={''}
                    activeTab={activeTab}
                  />
                </div>
              ))
            ) : (
              <div
                style={{
                  padding: '40px',
                  textAlign: 'center',
                }}>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Red Hat Display Medium',
                    fontSize: '14px',
                  }}>
                  No matches found
                </Typography>
              </div>
            )}
          </div>
        ) : (
          // Shortlisted Tab
          <div>
            {shortlisted.length > 0 ? (
              shortlisted.map((candidate) => (
                <CandidateCard
                  key={candidate.id}
                  matchPercentage={candidate.matchPercentage}
                  visaStatus={candidate?.candidate?.workStatus?.name}
                  source={candidate?.candidate?.source}
                  name={
                    candidate?.candidate?.firstName
                      ? candidate?.candidate?.firstName
                      : '' + ' ' + candidate?.candidate?.middleName
                      ? candidate?.candidate?.middleName
                      : '' + ' ' + candidate?.candidate?.lastName
                      ? candidate?.candidate?.lastName
                      : ''
                  }
                  availability={candidate?.candidate?.benchStatus}
                  availabilityDate={candidate?.candidate?.benchAvailability}
                  email={candidate?.candidate?.email}
                  phone={
                    candidate?.candidate?.phone ||
                    candidate?.candidate?.mobileNumber
                  }
                  location={
                    candidate.candidate?.city +
                    ', ' +
                    candidate.candidate?.state +
                    ', ' +
                    candidate.candidate?.country
                  }
                  isSelected={(candidate as any).selectedForSubmit}
                  topSkills={candidate?.candidate?.candidateSkills
                    ?.map((skill) => skill?.skill?.name)
                    .filter(Boolean)
                    .join(', ')}
                  onSelect={(selected) =>
                    handleSelectCandidate(candidate.id, selected)
                  }
                  onExpand={() => handleExpandCandidate(candidate.id)}
                  isShortList={true}
                  submittedOn={candidate?.submittedAt}
                  submittedBy={
                    candidate?.submittedUser?.firstName +
                    ' ' +
                    candidate?.submittedUser?.lastName
                  }
                  activeTab={activeTab}
                />
              ))
            ) : (
              <div
                style={{
                  padding: '40px',
                  textAlign: 'center',
                }}>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Red Hat Display Medium',
                    fontSize: '14px',
                  }}>
                  No shortlisted candidates
                </Typography>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Footer submit action for Shortlisted tab */}
      {activeTab === 1 && shortlisted.length > 0 && (
        <div
          style={{
            alignItems: 'center',
            background: '#ffffff',
            borderTop: '1px solid #e5e7eb',
            bottom: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            left: 0,
            padding: '12px 24px',
            position: 'sticky',
            right: 0,
          }}>
          <Button
            variant="contained"
            onClick={handleOpenConfirm}
            disabled={selectedShortlist.length === 0}
            sx={{
              '&:disabled': { opacity: 0.5 },
              '&:hover': { background: '#111827' },
              background: '#111827',
              borderRadius: '8px',
              boxShadow: 'none',
              textTransform: 'none',
            }}>
            {`Mark as Submitted (${selectedShortlist.length})`}
          </Button>
        </div>
      )}

      {/* Confirmation Dialog */}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openConfirm}
        onClose={handleCloseConfirm}
        PaperProps={{
          style: {
            borderRadius: '12px',
          },
        }}>
        <DialogTitle
          sx={{
            color: '#111827',
            fontFamily: 'Red Hat Display SemiBold',
            fontSize: '18px',
          }}>
          {`Submit Candidates (${selectedShortlist.length} Selected)`}
          <Typography
            sx={{
              color: '#6b7280',
              fontFamily: 'Red Hat Display Medium',
              fontSize: '14px',
              marginBottom: '12px',
            }}>
            Review and confirm the candidates you want to submit.
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleCloseConfirm}
            sx={{
              '&:hover': {
                backgroundColor: '#f3f4f6',
              },
              color: '#6b7280',
              position: 'absolute',
              right: 8,
              top: 8,
            }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{ padding: isSmDown ? '12px 16px' : '16px 24px' }}>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {selectedShortlist.map((c) => (
              <div
                key={c.id}
                style={{
                  backgroundColor: '#FAFAFA',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  padding: isSmDown ? '10px' : '12px',
                }}>
                {/* Top Row - Checkbox, Match Percentage, Tags */}
                <div
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '12px',
                  }}>
                  <div
                    style={{
                      alignItems: 'center',
                      display: 'flex',
                      gap: '10px',
                    }}>
                    {/* Match Percentage Circle */}
                    <div
                      style={{
                        alignItems: 'center',
                        backgroundColor: getMatchColor(c.matchPercentage),
                        border: '1px solid #7995E8',
                        borderRadius: '9999px',
                        color: '#2453C3',
                        display: 'flex',
                        fontFamily: 'Red Hat Display semibold',
                        fontSize: '12px',
                        fontWeight: '600',
                        justifyContent: 'center',
                        minHeight: '22px',
                        minWidth: '40px',
                        padding: '4px',
                      }}>
                      {c.matchPercentage}%
                    </div>

                    {/* Tags */}
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <Chip
                        label={c.candidate.workStatus?.name}
                        size="small"
                        sx={{
                          backgroundColor: '#F0F0F0',
                          border: '1px solid #DBDBDB',
                          color: '#7C7C7C',
                          fontFamily: 'Red Hat Display semibold',
                          fontSize: '12px',
                          fontWeight: '500',
                          height: '20px',
                          padding: '4px',
                        }}
                      />
                      <Chip
                        label={c.candidate?.source}
                        size="small"
                        sx={{
                          backgroundColor: '#FFE3E3',
                          border: '1px solid #E87979',
                          color: '#C32424',
                          fontFamily: 'Red Hat Display semibold',
                          fontSize: '12px',
                          fontWeight: '500',
                          height: '20px',
                          padding: '4px',
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Candidate Name and Availability Row */}
                <div
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    gap: '12px',
                    marginBottom: '8px',
                  }}>
                  <Checkbox
                    checked={(c as any).selectedForSubmit || false}
                    onChange={(e) =>
                      handleSelectCandidate(c.id, e.target.checked)
                    }
                    sx={{
                      '&.Mui-checked': { color: '#616161' },
                      color: '#979797 !important',
                      padding: '4px',
                    }}
                  />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '12px',
                    }}>
                    <div style={{ display: 'flex', gap: '12px' }}>
                      {/* Candidate Name */}
                      <Typography
                        sx={{
                          color: '#242424',
                          fontFamily: 'Red Hat Display bold',
                          fontSize: '14px',
                          fontWeight: '600',
                        }}>
                        {`${c?.candidate?.firstName || ''} ${
                          c?.candidate?.middleName || ''
                        } ${c?.candidate?.lastName || ''}`}
                      </Typography>

                      {/* Availability */}
                      <div
                        style={{
                          alignItems: 'center',
                          display: 'flex',
                        }}>
                        <CheckCircleIcon
                          sx={{
                            color: '#0E700E',
                            fontFamily: 'Red Hat Display semibold',
                            fontSize: '12px',
                            fontWeight: '600',
                            marginRight: '6px',
                          }}
                        />
                        <Typography
                          sx={{
                            color: '#0E700E',
                            fontFamily: 'Red Hat Display semibold',
                            fontSize: '12px',
                            fontWeight: '600',
                            marginRight: '6px',
                          }}>
                          {c?.candidate?.benchStatus}
                        </Typography>
                        <span
                          style={{
                            backgroundColor: '#0E700E',
                            borderRadius: '100%',
                            height: '4px',
                            marginRight: '6px',
                            width: '4px',
                          }}
                        />
                        <Typography
                          sx={{
                            color: '#0E700E',
                            fontFamily: 'Red Hat Display semibold',
                            fontSize: '12px',
                            fontWeight: '600',
                            marginRight: '6px',
                          }}>
                          {c?.candidate?.benchAvailability}
                        </Typography>
                      </div>
                    </div>
                    {/* Contact Information */}
                    <div
                      style={{
                        alignItems: 'center',
                        display: 'flex',
                        gap: '8px',
                        // marginBottom: isExpanded ? '16px' : '0',
                      }}>
                      <Typography
                        sx={{
                          color: '#616161',
                          fontFamily: 'Red Hat Display Medium',
                          fontSize: '13px',
                          marginBottom: '2px',
                        }}>
                        {c?.candidate?.email}
                      </Typography>
                      <span
                        style={{
                          backgroundColor: '#D9D9D9',
                          borderRadius: '100%',
                          height: '4px',
                          width: '4px',
                        }}
                      />
                      <Typography
                        sx={{
                          color: '#616161',
                          fontFamily: 'Red Hat Display Medium',
                          fontSize: '13px',
                          marginBottom: '2px',
                        }}>
                        {c?.candidate?.phone || c?.candidate?.mobileNumber}
                      </Typography>
                      <span
                        style={{
                          backgroundColor: '#D9D9D9',
                          borderRadius: '100%',
                          height: '4px',
                          width: '4px',
                        }}
                      />
                      <Typography
                        sx={{
                          color: '#616161',
                          fontFamily: 'Red Hat Display Medium',
                          fontSize: '13px',
                        }}>
                        {(c?.candidate?.city ||
                          c?.candidate?.state ||
                          c?.candidate?.country) && (
                          <span>
                            {[
                              c?.candidate?.city,
                              c?.candidate?.state,
                              c?.candidate?.country,
                            ]
                              .filter(Boolean)
                              .join(', ')}
                          </span>
                        )}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
              // <div
              //   key={c.id}
              //   style={{
              //     background: '#FFFFFF',
              //     border: '1px solid #E5E7EB',
              //     borderRadius: '8px',
              //     padding: isSmDown ? '10px' : '12px',
              //   }}>
              //   <div
              //     style={{
              //       alignItems: 'flex-start',
              //       display: 'flex',
              //       gap: '12px',
              //     }}>
              //     {/* Match percentage pill */}
              //     <div
              //       style={{
              //         alignItems: 'center',
              //         background: '#EBF0FF',
              //         borderRadius: 8,
              //         color: '#1F3B9D',
              //         display: 'flex',
              //         fontSize: 12,
              //         fontWeight: 700,
              //         height: 40,
              //         justifyContent: 'center',
              //         minWidth: 40,
              //       }}>
              //       {`${Math.round(Number(c.matchPercentage || 0))}%`}
              //     </div>
              //     <div style={{ flex: 1 }}>
              //       {/* Name + Checkbox + Availability */}
              //       <div
              //         style={{
              //           alignItems: 'center',
              //           display: 'flex',
              //           gap: 12,
              //           marginBottom: 6,
              //         }}>
              //         <Checkbox
              //           checked
              //           disabled
              //           sx={{
              //             '&.Mui-checked': { color: '#616161' },
              //             color: '#979797 !important',
              //             padding: '4px',
              //           }}
              //         />
              //         <Typography
              //           sx={{
              //             color: '#111827',
              //             fontSize: '14px',
              //             fontWeight: 600,
              //           }}>
              //           {`${c?.candidate?.firstName || ''} ${
              //             c?.candidate?.middleName || ''
              //           } ${c?.candidate?.lastName || ''}`}
              //         </Typography>
              //         <div style={{ alignItems: 'center', display: 'flex' }}>
              //           <CheckCircleIcon
              //             sx={{
              //               color: '#0E700E',
              //               fontSize: '12px',
              //               fontWeight: '600',
              //               marginLeft: '8px',
              //               marginRight: '6px',
              //             }}
              //           />
              //           <Typography
              //             sx={{
              //               color: '#0E700E',
              //               fontSize: '12px',
              //               fontWeight: '600',
              //               marginRight: '6px',
              //             }}>
              //             {c?.candidate?.benchStatus}
              //           </Typography>
              //           <span
              //             style={{
              //               backgroundColor: '#0E700E',
              //               borderRadius: '100%',
              //               height: '4px',
              //               marginRight: '6px',
              //               width: '4px',
              //             }}
              //           />
              //           <Typography
              //             sx={{
              //               color: '#0E700E',
              //               fontSize: '12px',
              //               fontWeight: '600',
              //             }}>
              //             {c?.candidate?.benchAvailability}
              //           </Typography>
              //         </div>
              //       </div>
              //       <div
              //         style={{
              //           display: 'flex',
              //           flexWrap: 'wrap',
              //           gap: 8,
              //           margin: '6px 0 8px',
              //         }}>
              //         {c?.candidate?.workStatus?.name && (
              //           <span
              //             style={{
              //               background: '#F9FAFB',
              //               border: '1px solid #E5E7EB',
              //               borderRadius: 16,
              //               color: '#374151',
              //               fontSize: 12,
              //               padding: '2px 8px',
              //             }}>
              //             {c?.candidate?.workStatus?.name}
              //           </span>
              //         )}
              //         {c?.candidate?.source && (
              //           <span
              //             style={{
              //               background: '#F9FAFB',
              //               border: '1px solid #E5E7EB',
              //               borderRadius: 16,
              //               color: '#374151',
              //               fontSize: 12,
              //               padding: '2px 8px',
              //             }}>
              //             {c?.candidate?.source}
              //           </span>
              //         )}
              //         {c?.candidate?.benchStatus && (
              //           <span
              //             style={{
              //               background: '#ECFDF5',
              //               border: '1px solid #DEF7EC',
              //               borderRadius: 16,
              //               color: '#047857',
              //               fontSize: 12,
              //               padding: '2px 8px',
              //             }}>
              //             {c?.candidate?.benchStatus}
              //           </span>
              //         )}
              //         {c?.candidate?.benchAvailability && (
              //           <span
              //             style={{
              //               background: '#F9FAFB',
              //               border: '1px solid #E5E7EB',
              //               borderRadius: 16,
              //               color: '#374151',
              //               fontSize: 12,
              //               padding: '2px 8px',
              //             }}>
              //             {c?.candidate?.benchAvailability}
              //           </span>
              //         )}
              //       </div>
              //       <div
              //         style={{
              //           color: '#6b7280',
              //           display: 'flex',
              //           flexWrap: 'wrap',
              //           fontSize: 12,
              //           gap: 8,
              //         }}>
              //         <span>{c?.candidate?.email}</span>
              //         <span>•</span>
              //         <span>
              //           {c?.candidate?.phone || c?.candidate?.mobileNumber}
              //         </span>
              //         {(c?.candidate?.city ||
              //           c?.candidate?.state ||
              //           c?.candidate?.country) && (
              //           <>
              //             <span>•</span>
              //             <span>
              //               {[
              //                 c?.candidate?.city,
              //                 c?.candidate?.state,
              //                 c?.candidate?.country,
              //               ]
              //                 .filter(Boolean)
              //                 .join(', ')}
              //             </span>
              //           </>
              //         )}
              //       </div>
              //     </div>
              //   </div>
              // </div>
            ))}
          </div>
        </DialogContent>
        <DialogActions sx={{ padding: isSmDown ? '10px 16px' : '12px 24px' }}>
          <Button
            onClick={handleCloseConfirm}
            variant="outlined"
            sx={{
              '&:hover': { backgroundColor: '#FFFFFF', borderColor: '#D1D5DB' },
              backgroundColor: '#FFFFFF',
              border: '1px solid',
              borderColor: '#E5E7EB',
              color: '#6b7280',
              textTransform: 'none',
            }}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmitConfirm}
            variant="contained"
            sx={{
              '&:hover': { background: '#111827' },
              background: '#111827',
              borderRadius: '8px',
              textTransform: 'none',
            }}>
            Confirm Submission
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MatchesAndShortlist;
